import React, { useEffect, useState } from "react";
import { Modal, Card, Empty, Spin, Typography, Toast, Button } from "@douyinfe/semi-ui";
import { ManualApi, Manual } from "./api";

const { Text, Paragraph } = Typography;

interface Props {
  visible: boolean;
  onClose: () => void;
  onPicked: (newManual: Manual) => void;
}

export function TemplatePickerModal({ visible, onClose, onPicked }: Props) {
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState<Manual[]>([]);
  const [creatingId, setCreatingId] = useState<number | null>(null);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    ManualApi.templates()
      .then(setTemplates)
      .catch((e) => Toast.error("加载模板失败：" + (e?.message || "")))
      .finally(() => setLoading(false));
  }, [visible]);

  const onPick = async (id: number) => {
    setCreatingId(id);
    try {
      const m = await ManualApi.fromTemplate(id);
      Toast.success("已创建副本，可在编辑器中修改");
      onPicked(m);
      onClose();
    } catch (e: any) {
      Toast.error("创建失败：" + (e?.message || ""));
    } finally {
      setCreatingId(null);
    }
  };

  return (
    <Modal
      title="从模板创建"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
      ) : templates.length === 0 ? (
        <Empty description="暂无模板" />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {templates.map((t) => (
            <Card
              key={t.id}
              title={t.title}
              footer={
                <Button
                  theme="solid"
                  type="primary"
                  loading={creatingId === t.id}
                  onClick={() => onPick(t.id)}
                  style={{ width: "100%" }}
                >
                  从此模板创建
                </Button>
              }
            >
              <Paragraph ellipsis={{ rows: 3 }} type="tertiary">
                {t.summary || "(无摘要)"}
              </Paragraph>
              <Text type="tertiary" size="small">
                {t.htmlContent?.slice(0, 80).replace(/<[^>]+>/g, "")}…
              </Text>
            </Card>
          ))}
        </div>
      )}
    </Modal>
  );
}
